import { render, staticRenderFns } from "./OrganismPinInfoBox.vue?vue&type=template&id=03f88830&"
import script from "./OrganismPinInfoBox.vue?vue&type=script&lang=js&"
export * from "./OrganismPinInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPinInfoBox.vue?vue&type=style&index=0&id=03f88830&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingMoleculePinInfoContent: require('/app/components/molecules/project/building/MoleculePinInfoContent.vue').default})
